import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { StickerProvider } from './context/StickerContext';
import { ToastProvider } from './components/ui/Toast';
import { StickersPage } from './pages/StickersPage';
import { OrderSummaryPage } from './pages/OrderSummaryPage';
import { EditorPage } from './pages/EditorPage';
export function App() {
  return <StickerProvider data-id="element-0">
      <ToastProvider data-id="element-1">
        <HashRouter data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Navigate to="/stickers" replace data-id="element-5" />} data-id="element-4" />
            <Route path="/stickers" element={<StickersPage data-id="element-7" />} data-id="element-6" />
            <Route path="/stickers/order-summary" element={<OrderSummaryPage data-id="element-9" />} data-id="element-8" />
            <Route path="/stickers/editor" element={<EditorPage data-id="element-11" />} data-id="element-10" />
          </Routes>
        </HashRouter>
      </ToastProvider>
    </StickerProvider>;
}